const detectMobileBrowser = () => {
  // https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return (
    toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    }) ||
    // iPad on iOS 13+ in desktop mode - reports as "Mac" but has touch capability
    // Primary: maxTouchPoints > 1 is more reliable on newer iPadOS
    // Fallback: ontouchend check for older versions
    (navigator.userAgent.includes("Mac") &&
      (navigator.maxTouchPoints > 1 || "ontouchend" in document))
  );
};

export default detectMobileBrowser;

// Warning: because this is only set once, you'll need to refresh the page to change whether isMobileBrowser is true/false
export const isMobileBrowser = detectMobileBrowser();

// True for an iPad-class device only (NOT an iPhone/iPod or Android phone).
// iPadOS 13+ reports its UA as "Mac" in the default desktop-mode Safari, so a
// touch-capable "Mac" is treated as an iPad; a real desktop Mac has no touch.
// Used to reserve the tablet recording toolbar for iPads while every actual
// phone gets the phone toolbar regardless of width/orientation.
export const isIpad = () => {
  const ua = navigator.userAgent;
  return (
    /iPad/i.test(ua) ||
    (ua.includes("Mac") &&
      (navigator.maxTouchPoints > 1 || "ontouchend" in document))
  );
};
